import ExtensionSkillIconSvg from './ExtensionSkill.svg?react';

const ExtensionSkillIcon = () => {
    return (
        <ExtensionSkillIconSvg />
    );
};

export default ExtensionSkillIcon;